import type { HTMLAttributes, ReactNode, Ref } from 'react';

import { cn } from '../cn';

export type ScrollableProps = HTMLAttributes<HTMLDivElement> & {
  innerClassName?: string;
  ref?: Ref<HTMLDivElement>;
  children?: ReactNode;
};

/**
 * Scrollable container that takes full width/height and enables vertical scrolling.
 */
export function Scrollable({ className, innerClassName, children, id, ref }: ScrollableProps) {
  return (
    <div ref={ref} className={cn('relative size-full grow basis-0 overflow-auto', className)} id={id}>
      <div className={cn('overflow-hidden', innerClassName)}>{children}</div>
    </div>
  );
}
